export const ACCESS_RIGHTS = {

  //#region CORE
  CORE_SECURITY_USERS: 1001,
  CORE_SECURITY_ROLES: 1002,
  CORE_SECURITY_AUDITLOGS: 1003,
  CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER: 1004,
  CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR: 1005,
  CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER: 1006,
  //#endregion

  //#region NATIONAL ACADEMY OF SPORTS
  NAS_STATICDATA_BUILDINGLOCATIONS: 2201,
  NAS_STATICDATA_GUIDANCECOUNSELORSESSIONTYPES: 2202,
  NAS_STATICDATA_CLINICVISITTYPES: 2203,
  NAS_STATICDATA_CLOCKINDEVICES: 2204,
  NAS_STATICDATA_GRADELEVELS: 2205,
  NAS_STATICDATA_SECTIONS: 2206,
  NAS_STATICDATA_RFIDCARDS: 2207,
  NAS_STATICDATA_ROOMS: 2208,
  NAS_STATICDATA_SPORTS: 2209,
  NAS_STATICDATA_GUIDANCEVISITTYPES: 2210,
  NAS_STATICDATA_INCIDENTSANCTIONS: 2211,

  NAS_STUDENTS: 2301,
  NAS_STUDENTS_ASSIGNRFID: 2302,
  NAS_STUDENTS_REMOVERFID: 2303,
  NAS_TRANSACTIONS_CHECKINS: 2304,
  NAS_TRANSACTIONS_CLINICVISITS: 2305,
  NAS_TRANSACTIONS_GUIDANCECOUNSELORVISITS: 2306,
  NAS_TRANSACTIONS_DORMITORYVISITS: 2307,
  NAS_STUDENTS_MEDICALINFO: 2308,
  NAS_STUDENTS_LOGS: 2309,
  NAS_STUDENTS_UPDATE_ROOM: 2310,
  NAS_TRANSACTIONS_MERITS: 2311,
  //#endregion

  //#region FMS
  FMS_DASHBOARD_ACCOUNTING: 3001,
  FMS_DASHBOARD_BUDGET: 3002,
  FMS_DASHBOARD_COLLECTION: 3003,
  FMS_DASHBOARD_DISBURSEMENT: 3004,

  FMS_ASSETS: 3301,

  FMS_BUDGET_BURS: 3401,
  FMS_BUDGET_GAAS: 3402,
  FMS_BUDGET_PPAS: 3403,
  FMS_BUDGET_SAROS: 3404,

  FMS_STATICDATA_ACCOUNTABLEFORMS: 3501,
  FMS_STATICDATA_ACCOUNTCLASSIFICATIONS: 3502,
  FMS_STATICDATA_ALLOTMENTSOURCEDOCUMENTTYPES: 3503,
  FMS_STATICDATA_AUTHORIZATIONCODES: 3504,
  FMS_STATICDATA_BANKS: 3505,
  FMS_STATICDATA_BANKBRANCHES: 3506,
  FMS_STATICDATA_BANKACCOUNTS: 3507,
  FMS_STATICDATA_CLIENTS: 3508,
  FMS_STATICDATA_DOCUMENTTYPES: 3509,
  FMS_STATICDATA_FUNDINGSOURCES: 3510,
  FMS_STATICDATA_FINANCINGSOURCES: 3511,
  FMS_STATICDATA_FUNDCATEGORIES: 3512,
  FMS_STATICDATA_FUNDSUBCATEGORIES: 3513,
  FMS_STATICDATA_FUNDCLUSTERS: 3513,
  FMS_STATICDATA_GENERALLEDGERS: 3514,
  FMS_STATICDATA_OBJECTCODES: 3515,
  FMS_STATICDATA_RESPONSIBILITYCENTERS: 3516,
  FMS_STATICDATA_SUBOBJECTCODES: 3517,
  FMS_STATICDATA_SUBSIDIARYLEDGERS: 3518,
  FMS_STATICDATA_TRANSACTIONTYPES: 3519,

  FMS_TRANSACTIONS_APPROPRIATIONS_VIEWER: 3601,
  FMS_TRANSACTIONS_APPROPRIATIONS_REQUESTOR: 3602,
  FMS_TRANSACTIONS_APPROPRIATIONS_APPROVER: 3603,
  FMS_TRANSACTIONS_NOTICEOFCASHALLOCATIONS_VIEWER: 3601,
  FMS_TRANSACTIONS_NOTICEOFCASHALLOCATIONS_REQUESTOR: 3602,
  FMS_TRANSACTIONS_NOTICEOFCASHALLOCATIONS_APPROVER: 3603,
  FMS_TRANSACTIONS_LDDAP_VIEWER: 3601,
  FMS_TRANSACTIONS_LDDAP_REQUESTOR: 3602,
  FMS_TRANSACTIONS_LDDAP_APPROVER: 3603,

  FMS_TRANSACTIONS_ALLOTMENTS_VIEWER: 3604,
  FMS_TRANSACTIONS_ALLOTMENTS_REQUESTOR: 3605,
  FMS_TRANSACTIONS_ALLOTMENTS_APPROVER: 3606,
  FMS_TRANSACTIONS_CASHDISBURSEMENTS_VIEWER: 3607,
  FMS_TRANSACTIONS_CASHDISBURSEMENTS_REQUESTOR: 3608,
  FMS_TRANSACTIONS_CASHDISBURSEMENTS_APPROVER: 3609,
  FMS_TRANSACTIONS_CHECKDISBURSEMENTS_VIEWER: 3610,
  FMS_TRANSACTIONS_CHECKDISBURSEMENTS_REQUESTOR: 3611,
  FMS_TRANSACTIONS_CHECKDISBURSEMENTS_APPROVER: 3612,
  FMS_TRANSACTIONS_COLLECTIONS_VIEWER: 3613,
  FMS_TRANSACTIONS_COLLECTIONS_REQUESTOR: 3614,
  FMS_TRANSACTIONS_COLLECTIONS_APPROVER: 3615,
  FMS_TRANSACTIONS_DEPOSITS_VIEWER: 3616,
  FMS_TRANSACTIONS_DEPOSITS_REQUESTOR: 3617,
  FMS_TRANSACTIONS_DEPOSITS_APPROVER: 3618,
  FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_VIEWER: 3619,
  FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_REQUESTOR: 3620,
  FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_REVIEWER: 3621,
  FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_FUNDER: 3622,
  FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_APPROVER: 3623,
  FMS_TRANSACTIONS_JOURNALENTRYVOUCHERS_VIEWER: 3624,
  FMS_TRANSACTIONS_JOURNALENTRYVOUCHERS_REQUESTOR: 3625,
  FMS_TRANSACTIONS_JOURNALENTRYVOUCHERS_APPROVER: 3626,
  FMS_TRANSACTIONS_OBLIGATIONS_VIEWER: 3627,
  FMS_TRANSACTIONS_OBLIGATIONS_REQUESTOR: 3628,
  FMS_TRANSACTIONS_OBLIGATIONS_APPROVER: 3629,
  FMS_TRANSACTIONS_ORDEROFPAYMENTS_VIEWER: 3630,
  FMS_TRANSACTIONS_ORDEROFPAYMENTS_REQUESTOR: 3631,
  FMS_TRANSACTIONS_ORDEROFPAYMENTS_APPROVER: 3632,
  FMS_TRANSACTIONS_PREPAYMENTS_VIEWER: 3633,
  FMS_TRANSACTIONS_PREPAYMENTS_REQUESTOR: 3634,
  FMS_TRANSACTIONS_PREPAYMENTS_APPROVER: 3635,

  FMS_REPORTS_CLIENTMASTERLISTREPORT: 3801,
  FMS_REPORTS_COLLECTIONSREPORT: 3802,
  FMS_REPORTS_ORDEROFPAYMENTREPORT: 3803,
  //#endregion

  //#region PEOPLESYNC
  PEOPLESYNC_DASHBOARD_EMPLOYEES: 4001,

  PEOPLESYNC_EMPLOYEES: 4101,
  PEOPLESYNC_EMPLOYEES_PERSONALINFORMATION: 4102,
  PEOPLESYNC_EMPLOYEES_MEDICALINFORMATION: 4103,
  PEOPLESYNC_EMPLOYEES_WORKINFORMATION: 4104,
  PEOPLESYNC_EMPLOYEES_SALARYINFORMATION: 4105,
  PEOPLESYNC_EMPLOYEES_BANKINFORMATION: 4106,
  PEOPLESYNC_EMPLOYEES_SERVICERECORDS: 4107,
  PEOPLESYNC_EMPLOYEES_PERSONALDATASHEET: 4108,

  PEOPLESYNC_STATICDATA_BRANCHES: 4501,
  PEOPLESYNC_STATICDATA_DEPARTMENTS: 4502,
  PEOPLESYNC_STATICDATA_EDUCATIONLEVELS: 4503,
  PEOPLESYNC_STATICDATA_EMPLOYMENTTYPES: 4504,
  PEOPLESYNC_STATICDATA_HOLIDAYTYPES: 4505,
  PEOPLESYNC_STATICDATA_LEAVETYPES: 4506,
  PEOPLESYNC_STATICDATA_NATIONALITIES: 4507,
  PEOPLESYNC_STATICDATA_PLANTILLAS: 4508,
  PEOPLESYNC_STATICDATA_POSITIONS: 4509,
  PEOPLESYNC_STATICDATA_RELATIONSHIPTYPES: 4510,
  PEOPLESYNC_STATICDATA_SALARYGRADES: 4511,
  PEOPLESYNC_STATICDATA_SALARYTYPES: 4512,
  PEOPLESYNC_STATICDATA_SCHOOLS: 4513,
  PEOPLESYNC_STATICDATA_SEPARATIONCAUSETYPES: 4514,
  PEOPLESYNC_STATICDATA_SERVICERECORDTYPES: 4515,
  PEOPLESYNC_STATICDATA_SKILLS: 4516,
  PEOPLESYNC_STATICDATA_WORKSCHEDULES: 4517,

  PEOPLESYNC_TRANSACTIONS_CERTIFICATEOFEMPLOYMENT_VIEWER: 4601,
  PEOPLESYNC_TRANSACTIONS_CERTIFICATEOFEMPLOYMENT_REQUESTOR: 4602,
  PEOPLESYNC_TRANSACTIONS_CERTIFICATEOFEMPLOYMENT_APPROVER: 4603,
  PEOPLESYNC_TRANSACTIONS_201FILECOPY_VIEWER: 4604,
  PEOPLESYNC_TRANSACTIONS_201FILECOPY_REQUESTOR: 4605,
  PEOPLESYNC_TRANSACTIONS_201FILECOPY_APPROVER: 4606,
  PEOPLESYNC_TRANSACTIONS_LEAVE_VIEWER: 4607,
  PEOPLESYNC_TRANSACTIONS_LEAVE_REQUESTOR: 4608,
  PEOPLESYNC_TRANSACTIONS_LEAVE_APPROVER: 4609,
  PEOPLESYNC_TRANSACTIONS_OVERTIME_VIEWER: 4610,
  PEOPLESYNC_TRANSACTIONS_OVERTIME_REQUESTOR: 4611,
  PEOPLESYNC_TRANSACTIONS_OVERTIME_APPROVER: 4612,
  PEOPLESYNC_TRANSACTIONS_SERVICERECORDCOPY_VIEWER: 4613,
  PEOPLESYNC_TRANSACTIONS_SERVICERECORDCOPY_REQUESTOR: 4614,
  PEOPLESYNC_TRANSACTIONS_SERVICERECORDCOPY_APPROVER: 4615,
  PEOPLESYNC_TRANSACTIONS_TRAINING_VIEWER: 4616,
  PEOPLESYNC_TRANSACTIONS_TRAINING_REQUESTOR: 4617,
  PEOPLESYNC_TRANSACTIONS_TRAINING_APPROVER: 4618,
  PEOPLESYNC_TRANSACTIONS_WORKFROMHOME_VIEWER: 4619,
  PEOPLESYNC_TRANSACTIONS_WORKFROMHOME_REQUESTOR: 4620,
  PEOPLESYNC_TRANSACTIONS_WORKFROMHOME_APPROVER: 4621,
  //#endregion

  //#region PAYFLOW
  PAYFLOW_DASHBOARD: 4001,
  //#endregion

  //#region FLEETCOMMAND
  FLEETCOMMAND_VEHICLES_TRACKING: 5001,
  FLEETCOMMAND_VEHICLES: 5002,
  FLEETCOMMAND_VEHICLES_REGISTRATION: 5003,
  FLEETCOMMAND_VEHICLES_VEHICLE_INSURANCE: 5004,
  FLEETCOMMAND_VEHICLES_VEHICLE_TRACKING: 5005,

  FLEETCOMMAND_SETTINGS_PERSONNELS: 5501,
  FLEETCOMMAND_SETTINGS_FUEL_TYPES: 5502,
  FLEETCOMMAND_SETTINGS_VEHICLE_BRANDS: 5503,
  FLEETCOMMAND_SETTINGS_VEHICLE_MODELS: 5504,
  FLEETCOMMAND_SETTINGS_VEHICLE_TYPES: 5505,

  FLEETCOMMAND_TRANSACTIONS_FUEL_TOPUP_REQUEST_VIEWER: 5601,
  FLEETCOMMAND_TRANSACTIONS_FUEL_TOPUP_REQUEST_REQUESTOR: 5602,
  FLEETCOMMAND_TRANSACTIONS_FUEL_TOPUP_REQUEST_APPROVER: 5603,
  FLEETCOMMAND_TRANSACTIONS_RFID_TOPUP_REQUEST_VIEWER: 5604,
  FLEETCOMMAND_TRANSACTIONS_RFID_TOPUP_REQUEST_REQUESTOR: 5605,
  FLEETCOMMAND_TRANSACTIONS_RFID_TOPUP_REQUEST_APPROVER: 5606,
  FLEETCOMMAND_TRANSACTIONS_SERVICE_MAINTENANCE_REQUEST_VIEWER: 5607,
  FLEETCOMMAND_TRANSACTIONS_SERVICE_MAINTENANCE_REQUEST_REQUESTOR: 5608,
  FLEETCOMMAND_TRANSACTIONS_SERVICE_MAINTENANCE_REQUEST_APPROVER: 5609,
  //#endregion

  //#region DOCUMENT MANAGEMENT SYSTEM
  DMS_DASHBOARD: 6001,
  //#endregion

  //#region GLOBO ASIATICO
  GLOBO_PATIENTS: 8101,
  GLOBO_PATIENTS_PRESCRIPTIONS: 8102,
  GLOBO_PATIENTS_ORDERS: 8103,
  GLOBO_PATIENTS_FILES: 8104,
  GLOBO_PATIENTS_LOGS: 8105,

  GLOBO_STATICDATA_DIAGNOSIS: 8501,
  GLOBO_STATICDATA_DOCTORS: 8502,
  GLOBO_STATICDATA_DROPOUTREASONS: 8503,
  GLOBO_STATICDATA_HOSPITALS: 8504,
  GLOBO_STATICDATA_PAPSCHEMES: 8505,
  GLOBO_STATICDATA_PATIENTSEGMENTS: 8506,
  GLOBO_STATICDATA_PRINCIPALS: 8507,
  GLOBO_STATICDATA_PRODUCTS: 8508,
  GLOBO_STATICDATA_PROGRAMS: 8509,
  GLOBO_STATICDATA_PURCHASINGACCOUNTS: 8510,
  GLOBO_STATICDATA_SPECIALIZATIONS: 8511,
  GLOBO_STATICDATA_THERAPEUTICAREAS: 8512,
  GLOBO_STATICDATA_TREATMENTSTATUSES: 8513,
  GLOBO_STATICDATA_UOMS: 8514,

  GLOBO_TRANSACTIONS_ADVERSEEVENTS: 8601,

  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_VIEWER: 8602,
  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_REQUESTOR: 8603,
  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_APPROVER: 8604,

  GLOBO_TRANSACTIONS_LOAREQUESTS_VIEWER: 8605,
  GLOBO_TRANSACTIONS_LOAREQUESTS_REQUESTOR: 8606,
  GLOBO_TRANSACTIONS_LOAREQUESTS_APPROVER: 8607,

  GLOBO_TRANSACTIONS_ORDERREQUESTS_VIEWER: 8608,
  GLOBO_TRANSACTIONS_ORDERREQUESTS_REQUESTOR: 8609,
  GLOBO_TRANSACTIONS_ORDERREQUESTS_APPROVER: 8610,
  GLOBO_TRANSACTIONS_ORDERREQUESTS_SET_RECEIVED: 8611,

  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_VIEWER: 8612,
  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_REQUESTOR: 8613,
  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_APPROVER: 8614,

  GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_VIEWER: 8615,
  GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_REQUESTOR: 8616,
  GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_APPROVER: 8617,
  //#endregion GLOBO ASIATICO
};
